// services/simulation.service.ts
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, switchMap, catchError } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { RenovaPlusService } from './renova-plus.service';
import { SelectedDnService } from './selected-dn.service';

export interface LeadInsertPayload {
  // Campos necessários para inserir lead
  // Adapte conforme a API real
  idSimulacao?: string;
  cpfCnpj?: string;
  dataSimulacao?: string;
  cdSiglaTipo?: string; // "SO" para Simulações Online
  flRenovacao?: 'S' | 'N';
  // Outros campos...
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class SimulationService extends BaseApiService {

  constructor(
    http: HttpClient,
    private renovaPlusService: RenovaPlusService,
    private selectedDnService: SelectedDnService,
    // ...existing code...
  ) {
    super(http);
  }

  GetAndUpdateSimulation(idSimulacao: string | null, idLead: string | null, token: string | null): Observable<any> {
    const dn = this.selectedDnService.getSelectedDn();
    if (!dn) {
      throw new Error('DN não selecionado');
    }
    const endpoint = `/simulacoes?idSimulacao=${idSimulacao}&idLead=${idLead}&token=${token}&dn=${dn}`;
    return this.get<any>(endpoint);
  }

  /**
   * Insere um novo lead aplicando a regra VW-98 de Renova+ se aplicável
   * Nota: A elegibilidade agora é determinada apenas pelo flag_renovacao do backend
   * @param payload Dados do lead a ser inserido
   * @returns Observable com o resultado da inserção
   */
  inserirLeadComRenovaPlus(payload: LeadInsertPayload): Observable<any> {
    const dn = this.selectedDnService.getSelectedDn();
    if (!dn) {
      throw new Error('DN não selecionado');
    }
    const baseEndpoint = `/lead`;
    // Verificar se é Simulação Online
    if (payload.cdSiglaTipo !== 'SO') {
      // Não é simulação online, inserir normalmente sem Renova+
      payload.flRenovacao = 'N';
      return this.post<any>(baseEndpoint, payload);
    }

    // É simulação online, verificar Renova+ via backend flag
    if (!payload.cpfCnpj) {
      // Dados insuficientes, marcar como N
      payload.flRenovacao = 'N';
      return this.post<any>(baseEndpoint, payload);
    }

    // Backend determina elegibilidade via flag_renovacao, frontend apenas consulta
    return this.renovaPlusService.verificarRenovaPlus(payload.cpfCnpj).pipe(
      switchMap(result => {
        // Marcar FL_RENOVACAO baseado no resultado do backend
        payload.flRenovacao = result.isRenovaPlus ? 'S' : 'N';
        return this.post<any>(baseEndpoint, payload);
      }),
      catchError(() => {
        // Em caso de erro na verificação, marcar como N e tentar inserir
        payload.flRenovacao = 'N';
        return this.post<any>(baseEndpoint, payload);
      })
    );
  }

  /**
   * Converte FL_RENOVACAO ('S'/'N') para renovaMais (boolean)
   */
  static flRenovacaoToRenovaMais(flRenovacao: 'S' | 'N' | undefined): boolean | null {
    if (flRenovacao === 'S') return true;
    if (flRenovacao === 'N') return false;
    return null;
  }

  /**
   * Converte renovaMais (boolean) para FL_RENOVACAO ('S'/'N')
   */
  static renovaMaisToFlRenovacao(renovaMais: boolean | null): 'S' | 'N' {
    return renovaMais === true ? 'S' : 'N';
  }

}
